import { Layouts } from "@/types/Layout.ts"
import type { Component } from "vue"
import type { RouteRecordRaw } from "vue-router"

export const SoUniqueRouteNames = {
  PRODUCT: "so-unique-product",
  ANALYSIS: "so-unique-analysis",
  OFFER: "so-unique-offer",
  CONFIRM: "so-unique-confirm",
  SUCCESS: "so-unique-success",
} as const

export const getSoUniqueTariffRoutesByLayout = (
  layout: Layouts,
): RouteRecordRaw[] => [
  {
    path: "/myaccount/so-unique/product",
    name: SoUniqueRouteNames.PRODUCT,
    component: (): Promise<Component> =>
      import("@/ai-generated/so-unique/views/SoUniqueProduct.vue"),
    meta: {
      requiresAuth: true,
      layout,
    },
  },
  {
    path: "/myaccount/so-unique/analysis",
    name: SoUniqueRouteNames.ANALYSIS,
    component: (): Promise<Component> =>
      import("@/ai-generated/so-unique/views/SoUniqueAnalysis.vue"),
    meta: {
      requiresAuth: true,
      layout,
    },
  },
  {
    path: "/myaccount/so-unique/offer",
    name: SoUniqueRouteNames.OFFER,
    component: (): Promise<Component> =>
      import("@/ai-generated/so-unique/views/SoUniqueOffer.vue"),
    meta: {
      requiresAuth: true,
      layout,
    },
  },
  {
    path: "/myaccount/so-unique/confirm",
    name: SoUniqueRouteNames.CONFIRM,
    component: (): Promise<Component> =>
      import("@/ai-generated/so-unique/views/SoUniqueConfirmSwitch.vue"),
    meta: {
      requiresAuth: true,
      layout,
    },
  },
  {
    path: "/myaccount/so-unique/success",
    name: SoUniqueRouteNames.SUCCESS,
    component: (): Promise<Component> =>
      import("@/ai-generated/so-unique/views/SoUniqueSuccess.vue"),
    meta: {
      requiresAuth: true,
      layout,
    },
  },
]
